<template>
  <div class="instructions">
    <h3>{{ $t("installation") }}</h3>
    <span class="instructions-title">{{ $t("titleFollowInstructions") }}</span>
    <div class="instructions-tabs">
      <md-tabs class="md-transparent">
        <md-tab v-bind:md-label="$t('instructions.title_outlook_windows')" @click="clickTabs('pc')">
          <div v-html="$t('instructions.outlook_windows')"></div>
        </md-tab>
        <md-tab v-bind:md-label="$t('instructions.title_outlook_mac')" @click="clickTabs('mac')">
          <div v-html="$t('instructions.outlook_mac')"></div>
        </md-tab>
        <md-tab v-bind:md-label="$t('instructions.title_webmail')" @click="clickTabs('webmail')">
          <div v-html="$t('instructions.webmail')"></div>
        </md-tab>
      </md-tabs>

    </div>

    <div class="instructions-btns">
      <button type="button" class="buttonSign buttonIntegrate" v-on:click="integrate">
        <div class="front">{{ $t("buttonIntegrate") }} &rsaquo;</div>
        <div class="back">{{ $t("buttonBack") }}</div>
      </button>
      <button
        ref="buttonTooltip"
        class="buttonSign buttonCopyCode"
        :class="['buttonSign', 'buttonCopyCode', { disabled: disabled }]" 
        v-on:click="copyCode()"
        v-bind:title="$t('copiedClipboard')"
        v-tippy="{ interactive : false, trigger: 'click' }"
      >{{ $t("buttonCopySignature") }}</button>
    </div>
    

  </div>
</template>

<script>
import EventBus from '../eventBus';

import Utils from '../utils';

export default {
  name: 'ESInstructions',
  data: function() {
    return {
      disabled: true,
      gaDatas: '',
    }
  },
  beforeDestroy: function () {
    this.clearTimer();
  },
  methods: {
    integrate: function() {
      EventBus.$emit('validateForm');
      Utils.generateTag('navigation-step2', 'click');
    },
    copyCode: function() {
      this.selectText('outlook-signature');
      this.createTimeoutHideTippy();
    },
    selectText: function(element) {
      const doc = document;
      const text = doc.getElementById(element);
      let range;
      let selection;
      if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
        document.execCommand("Copy");
        range.removeAllRanges();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("Copy");
        selection.removeAllRanges();
      }
      //console.log(text);
    },
    activateCopy: function(ready) {
      this.disabled = !ready;
    },
    clickTabs: function(datas) {
      Utils.generateTag('navigation-instructions', 'click', datas);
    },
    clearTimer: function () {
      if (this.timeoutid) {
        clearTimeout(this.timeoutid);
      }
    },
    createTimeoutHideTippy: function() {
      this.timeoutid = setTimeout(()=> {
        try {
          this.$refs['buttonTooltip']._tippy.hide();  
        } catch (error) {}
        this.clearTimer();
      }, 1000);
    }
  },
  mounted: function () {
    EventBus.$on('genaration-ready', this.activateCopy);
    
    const indicator = document.querySelector('.md-tabs-indicator');
    indicator.classList.add('tmp');
    indicator.style.backgroundColor = '#000';

  },
}
</script>


// WEBPACK FOOTER //
// src/components/Instructions.vue